import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IpAuthService } from '../../services/ip-auth.service';

@Component({
  selector: 'app-ip-button-modal',
  templateUrl: './ip-button-modal.component.html',
  styleUrls: ['./ip-button-modal.component.scss']
})
export class IpButtonModalComponent {
  @Input() typeBtn!: 'action' | 'cancel' | 'submit' | 'action2' | 'clean';
  @Input() size: 'small' | 'normal' | 'large' | 'table' = 'normal';
  @Input() disabled = false;
  @Input() styleButton?: string;
  @Output() clicked = new EventEmitter<any>();
  @Input() textCodeBtn?: string; 
  onlyRead: boolean = false;

  constructor(private authService: IpAuthService) {
    this.onlyRead = this.authService.isOnlyReadMode();
  }

  onClickButton(ev: MouseEvent) {
    this.clicked.emit(ev);
  }

}
